<template>
  <div class="editor-module-tabs">
    <button
      type="button"
      class="editor-module-tab"
      :class="{ 'is-active': isTemplateListActive }"
      @click="goToTemplateList"
    >
      {{ $t('product_template_list') }}
    </button>

    <button
      type="button"
      class="editor-module-tab"
      :class="{ 'is-active': isWorkInstructionsActive }"
      @click="goToWorkInstructions"
    >
      {{ $t('work_instructions.label') }}
    </button>

    <button
      type="button"
      class="editor-module-tab"
      :class="{ 'is-active': isInstructionPackagesActive }"
      @click="goToInstructionPackages"
    >
      {{ $t('work_instructions.instruction_packages.label') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EditorModuleTabs',
  computed: {
    isTemplateListActive() {
      return this.$route.name === 'editor-list';
    },
    isWorkInstructionsActive() {
      return [
        'editor-work-instructions-list',
        'editor-work-instructions-package',
      ].includes(this.$route.name);
    },
    isInstructionPackagesActive() {
      return this.$route.name === 'editor-instruction-packages-list';
    },
  },
  methods: {
    goToTemplateList() {
      if (!this.isTemplateListActive) {
        this.$router.push({ name: 'editor-list' });
      }
    },
    goToWorkInstructions() {
      if (!this.isWorkInstructionsActive) {
        this.$router.push({ name: 'editor-work-instructions-list' });
      }
    },
    goToInstructionPackages() {
      if (!this.isInstructionPackagesActive) {
        this.$router.push({ name: 'editor-instruction-packages-list' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.editor-module-tabs {
  display: flex;
  align-items: center;
  height: 100%;
}

.editor-module-tab {
  height: 100%;
  border: none;
  background: transparent;
  font-family: 'Siemens Sans';
  font-size: inherit;
  font-weight: 600;
  color: #333;
  padding: 0 14px;
  cursor: pointer;
  border-bottom: 3px solid transparent;
}

.editor-module-tab.is-active {
  border-bottom-color: #2f7de1;
}
</style>
